import React from "react"
import classnames from "classnames"
import AriaModal from "react-aria-modal"
import { IS_BROWSER } from "AtomicUtils/environment"
import { CrossIcon } from "AtomicComponents"
import styles from "./Modal.less"

class Modal extends React.PureComponent {
  render() {
    const { children, handleClose = () => { }, width, fullWidth = false } = this.props

    if (!IS_BROWSER) return null

    return (
      <AriaModal
        titleText="modal"
        onExit={handleClose}
        underlayClickExits={true}
        verticallyCenter
        focusDialog
        underlayStyle={{ padding: '0' }}
        dialogStyle={fullWidth ? { width: '100%', height: '100vh' } : {}}
      >
        <div
          className={classnames({
            [styles.Modal]: true,
            [styles.ModalFullWidth]: fullWidth
          })}
          style={{
            maxWidth: width
          }}>
          <div
            className={classnames({
              [styles.ModalClose]: true
            })}
            onClick={handleClose}>
            <CrossIcon />
          </div>
          {children}
        </div>
      </AriaModal>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/AtomicComponents/Modal/Modal.jsx